import { Component } from '@angular/core';
import {ActivitySpinnerComponent} from '../activity-spinner/activity-spinner.component';

@Component({
  selector: 'app-loading-spinner',
    imports: [
        ActivitySpinnerComponent
    ],
  templateUrl: './loading-spinner.component.html',
})
export class LoadingSpinnerComponent {

}
